export enum WorkStatus {
    employed = 1,
    selfemployed = 2,
    temporaryEmployment = 3,
    hourlyEmployment = 4,
    retired = 5,
    earlyRetirement = 6
}

export enum LoanPurpose {
    refinance = 1,
    renovation = 2,
    buyFurniture = 3,
    vehicle = 4,
    buyHouse = 5,
    vacation = 6,
    investment = 7,
    startBusiness = 8,
    propertySettlement = 9,
    estateInventory = 10,
    other = 11
}

export enum HomeStatus {
    rented = 1,
    house = 2,
    apartment = 3,
    roommate = 4,
    parents = 5
}

export enum CivilStatus {
    married = 1,
    single = 2,
    partner = 3
}